import { ClickAwayListener, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect } from "react";
import DetailsParams from "../../MainPage/Sections/ElementsSections/DetailsParams";
import { useAtom } from "jotai";
import { editorCash } from "../../../atoms";
import { EditorDetails } from "../Editor";
import { EventDataInfo } from "../../MainPage/Tools/VirtualList/VirtualList";

interface DetailsButtonProps {
  module?: string;
  details?: EditorDetails;
  disabled?: boolean;
  buttonRef?: React.MutableRefObject<HTMLButtonElement | null>;
  inputValue: string;
  valueChanged: React.MutableRefObject<boolean>;
  setValue?: React.Dispatch<React.SetStateAction<EventDataInfo>>;
  setInputValue?: React.Dispatch<React.SetStateAction<string>>;
}

export default function DetailsButton(props: DetailsButtonProps) {
  const { inputValue, valueChanged, buttonRef, details, disabled, module, setInputValue, setValue } = props;
  const buttonRefElement = React.useRef<HTMLButtonElement | null>(null);
  const popperRef = React.useRef(null);
  const [cash, setCash] = useAtom(editorCash);

  // функции для Popover(выпадающим полем) с выбором даты
  const [open, setOpen] = React.useState(false);
  const [position, setPosition] = React.useState({ x: 0, y: 0 });

  useEffect(() => {
    cash.detailsOpen && setOpen(cash.detailsOpen);
  }, []);

  useEffect(() => {
    if (open) {
      setPosition(getPosition());
      setCash({ ...cash, detailsOpen: true });
    }
  }, [open]);

  const handleClickDetails = () => {
    setOpen(!open);
  };
  // функция на закрытие
  const handleCloseDetails = (ev: any) => {
    if (
      ev.target === buttonRefElement.current?.closest("TD") ||
      (ev.target.closest(".background_ModalDialog") &&
        ev.target.closest(".background_ModalDialog") !==
          buttonRefElement.current?.closest(".background_ModalDialog")) ||
      ev.target.closest("[checklist]") ||
      ev.target.closest("[calendar]") ||
      ev.target.closest("[details]") ||
      ev.target.closest("[loadmask]") ||
      ev.target.classList.contains("MuiBackdrop-root")
    ) {
      return;
    }

    details?.updateRecord?.();
    setOpen(false);
    setCash({ ...cash, detailsOpen: false });
  };

  const getPosition = () => {
    if (!popperRef.current || !buttonRefElement.current) return { x: 0, y: 0 };
    const rootRect = document.querySelector("#root")?.getBoundingClientRect();
    if (!rootRect) return { x: 0, y: 0 };
    const buttonRect = buttonRefElement.current.getBoundingClientRect();

    const x = buttonRect.left - 400 < 0 ? 30 : buttonRect.left - 400 + 30;
    const y = buttonRect.top + 250 < rootRect.height - 100 ? buttonRect.top + 27 : buttonRect.top - 250;

    return { x, y };
  };

  return (
    <>
      <IconButton
        disabled={disabled}
        ref={(el) => {
          buttonRefElement.current = el;
          if (buttonRef) buttonRef.current = el;
        }}
        onClick={handleClickDetails}
        className="list-button"
        style={{
          width: "20px !important",
          height: "100%",
          borderRadius: "0px",
          padding: "0",
        }}
      >
        <ExpandMoreIcon style={{ maxHeight: "20px" }} />
      </IconButton>
      <div
        style={{
          position: "fixed",
          zIndex:
            !buttonRefElement.current || buttonRefElement.current.closest(".background_ModalDialog") === null
              ? "999"
              : buttonRefElement.current?.closest("DIV.background_ModalDialog")?.style.zIndex,
          left: position.x,
          top: position.y,
        }}
      >
        {open && (
          <ClickAwayListener onClickAway={handleCloseDetails}>
            <div
              tabIndex={0}
              onWheel={(ev) => {
                ev.stopPropagation();
              }}
              onKeyDown={(ev) => {
                ev.stopPropagation();
              }}
              ref={popperRef}
              details="true"
              style={{
                overflow: "auto",
                height: "fit-content",
                maxHeight: "250px",
                minHeight: "30px",
                minWidth: "400px",
                boxShadow: "rgba(0, 0, 0, 0.2) 3px 3px 3px 2px",
                border: "1px solid #cccccc",
                borderRadius: "7px",
              }}
            >
              <DetailsParams
                Module={module}
                ID={details?.ID}
                DocCfgID={details?.Details}
                NoTitle={true}
                NoHistory={true}
                data={details?.GetDetails}
                setParentEditorValueInput={setInputValue}
                setParentEditorValue={setValue}
                valueChanged={valueChanged}
                getText={details?.getText}
                updateRecord={details?.updateRecord}
                HardCodeReadOnlyForEditor={details?.HardCodeReadOnlyForEditor}
                AccDetails={details?.AccDetails}
                inputValue={inputValue}
                onList={details?.GetDetails.OnList}
                onListCustom={details?.GetDetails.OnListCustom}
                onEdit={details?.GetDetails.OnEdit}
                onEditCustom={details?.GetDetails.OnEditCustom}
                onCloseUpList={details?.GetDetails.OnCloseUpList}
                onCloseUpListCustom={details?.GetDetails.OnCloseUpListCustom}
              />
            </div>
          </ClickAwayListener>
        )}
      </div>
    </>
  );
}
